import { IAttachmentTitleReducer, IAttachmentTitle } from 'models/AttachmentTitle'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray } from 'helpers/helperFunctions'
import {
  GetAttachmentTitles,
  AttachmentTitlesFetching,
  UpdateAttachmentTitle,
  DeleteAttachmentTitle,
} from './actions'

const initialState: IAttachmentTitleReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const attachmentTitlesReducer = (
  state = initialState,
  action: Action
): IAttachmentTitleReducer => {
  if (isType(action, GetAttachmentTitles)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdateAttachmentTitle)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IAttachmentTitle>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteAttachmentTitle)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IAttachmentTitle>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, AttachmentTitlesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
